export async function browserSupportsPasskeyAutofill() {
    if (typeof window.PublicKeyCredential?.isConditionalMediationAvailable !== "function") {
        return false;
    }

    try {
        return await window.PublicKeyCredential.isConditionalMediationAvailable();
    } catch (error) {
        console.info("Could not determine webauthn autofill support", error);
        return false;
    }
}
